var parent = require('../../es/array/from');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/features/array/from.js
// module id = 1010
// module chunks = 0